import * as React from "react";
import {
  List,
  SimpleList,
  Datagrid,
  TextField,
  ListProps,
  NumberField,
  TextInput,
  ReferenceInput,
  SelectInput,
  useDataProvider,
  useListContext,
  GetListResult,
  Record
} from "react-admin";
import { useMediaQuery } from "@material-ui/core";

import { DateInput } from "react-admin";
import { TotalsContext } from './TotalsContext';

const VodTransactionFilters = () => {
  const filters = [
    <TextInput label="Search" source="q" alwaysOn />, 
    <ReferenceInput source="WebzoneUniverse" reference="WebzoneUniverse">
      <SelectInput optionText="name" />
    </ReferenceInput>,
    <DateInput label="Date min" source="date_min" alwaysOn />,
    <DateInput label="Date max" source="date_max" alwaysOn />,
  ];
  return filters;
};

export const VodTransactionList = (props: ListProps) => {
  const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));

 // Footer custom pour la Datagrid
  type VodTransactionRecord = {
    total_amount?: number;
    count?: number;
    [key: string]: any;
  };
  const DatagridWithFooter = () => {
    const dataProvider = useDataProvider();
    const { filterValues, currentSort, page, perPage, resource } = useListContext();

    const [totals, setTotals] = React.useState({total: 0, total_amount_sum: 0, total_transaction_count: 0});

    type VodTransactionListResult = {
      data: VodTransactionRecord[];
      total: number;
      total_amount_sum: number;
      total_transaction_count: number;
    };
    React.useEffect(() => {
      dataProvider
        .getList(resource, {
          pagination: { page, perPage }, // not used, no pagination for VOD transaction stats
          sort: currentSort,
          filter: filterValues,
        })
        .then(res => {
          const extended = res as GetListResult<Record> & VodTransactionListResult;
          setTotals({
            total: extended.total,
            total_amount_sum: extended.total_amount_sum,
            total_transaction_count: extended.total_transaction_count,
          });
        });
    }, [dataProvider, resource, filterValues, currentSort, page, perPage]);

    return (
      <TotalsContext.Provider value={totals}>
        <Datagrid>
          <TextField label="Titre" source="vod_title" />
          <TextField label="Slug" source="vod_slug" />
          <NumberField
            label="Montant Moyen sur la période"
            source="average_amount"
            locales="fr-FR"
            options={{ style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }}
          />
          <NumberField
            label="Montant Total"
            source="total_amount"
            locales="fr-FR"
            options={{ style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }}
          />
          {/* Pour l'affichage du symbole €, il faut surcharger le composant ou utiliser FunctionField si besoin d'un affichage custom */}
          <TextField label="Nombre d'achats" source="count" />
        </Datagrid>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10, marginBottom: 10, marginRight: 15, fontWeight: 'bold', fontSize: 'medium', color: 'cyan' }}>
          <span style={{ marginRight: 32 }}>Total: {totals.total}</span>
          <span style={{ marginRight: 32 }}>Total Montant: {totals.total_amount_sum.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 })}</span>
          <span>Total Achats: {totals.total_transaction_count}</span>
        </div>
      </TotalsContext.Provider>
    );
  };


  return (
    <List
      {...props}
      bulkActionButtons={false}
      filters={VodTransactionFilters()}
      pagination={false}
    >
      {isSmall ? (
        <SimpleList
          primaryText={(record) => `VOD - ${record.vod_title}`}
          secondaryText={(record) => `${record.count} achats`}
          tertiaryText={(record) => `${record.total_amount}€`}
        />
      ) : (
        <DatagridWithFooter />
      )}
    </List>
  );
};
